import { FormProvider } from "react-hook-form";
import { CreateOrderForm } from "@/widgets/create-order-form";
import BlockLoader from "@/Components/Loaders/BlockLoader";
import { usePromoteOrderForm } from "@/entities/new-order";

export const PromoteOrder = () => {
  const { methods, handleReset, isLoading } = usePromoteOrderForm();

  return (
    <FormProvider {...methods}>
      <CreateOrderForm handleReset={handleReset} />
      {isLoading ? <BlockLoader size="lg" /> : null}
    </FormProvider>
  );
};
